import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {EmployeeQuickCreate} from '@/components/employee-quick-create'
import type {Employee} from '@/hooks/empresa/identidad/use-employees'

/** Alta de un afectado que aún no está en la nómina (`POST /employees`, con dedup y gate de banda).
 * Compartido por los dos sitios que eligen afectado: una copia la rechazaría el gate de clones. */
export function AfectadoQuickCreateSlot({
  businessId,
  roster,
  rosterDenegado,
  oculto,
  onCreated,
}: {
  businessId: string
  roster: Employee[]
  // Sin el roster completo, que es de operadores, el dedup por cédula fallaría en silencio:
  // en vez del alta se explica de quién es ese acto.
  rosterDenegado: boolean
  oculto: boolean
  onCreated: (persona: Employee) => void
}) {
  const {t} = useTranslation()
  const [creandoPersona, setCreandoPersona] = useState(false)
  return (
    <>
      {!oculto &&
        !rosterDenegado &&
        (creandoPersona ? (
          <EmployeeQuickCreate
            businessId={businessId}
            roster={roster}
            onCreated={(persona) => {
              onCreated(persona)
              setCreandoPersona(false)
            }}
            onCancel={() => setCreandoPersona(false)}
          />
        ) : (
          <button
            type="button"
            data-testid="incidente-afectado-crear"
            onClick={() => setCreandoPersona(true)}
            className="inline-flex min-h-11 items-center font-mono text-[11px] text-primary hover:underline sm:min-h-0">
            {t('incidentes.reportar.altaRapida.abrir')}
          </button>
        ))}
      {rosterDenegado && (
        <p className="text-xs text-muted-foreground" data-testid="incidente-afectado-sin-roster">
          {t('incidentes.reportar.altaRapida.sinRoster')}
        </p>
      )}
    </>
  )
}
